import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-user-two",
  "use": "foquz-icon-user-two-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol viewBox=\"0 0 8 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-user-two\"><path d=\"M7 7c-.242-.294-.656-.546-1.188-.724A5.826 5.826 0 004.012 6a5.87 5.87 0 00-1.808.266c-.536.175-.955.425-1.204.718M5 2a1 1 0 11-2 0 1 1 0 012 0z\" stroke=\"#8EA6FF\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol